/**
 * Représente un rôle
 */

import { APIResource } from '@/core/resources/APIResource'
import type { Creatable, Updatable } from '@/core/resources/APIResource'

export class Role extends APIResource implements Creatable<Role>, Updatable<Role> {
  apiRoute: string = 'roles'

  name: string = ''

  getIdentifier() {
    return this.name
  }

  fromJson(json: RoleResponse): this {
    this.name = json.name
    return this
  }

  toJsonRequest(): RoleJsonRequest {
    return {
      name: this.name
    }
  }
}

export interface RoleResponse {
  name: string
}

export interface RoleJsonRequest {
  name: string
}

export default Role
